<style lang="scss">
.announcement-card {
  img, video {
    width: 100%;
    height: auto;
  }

  .soft-disable {
    pointer-events: none;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <section class="announcement-card">
    <div :id="`${announcement._id}-announcement-message`" class="mb-2">
    </div>
    <a :class="!announcement.image_link ? 'soft-disable' : ''" v-if="announcement.image_url" :href="announcement.image_link || 'javascript:void(0)'" target="_blank">
      <img class="mb-2" :src="announcement.image_url" alt="">
    </a>

    <video v-if="announcement.video_url" id="video-bg" width="500" height="300" class="mb-2" controls
           :src="announcement.video_url">
      Your browser does not support HTML video.
    </video>
  </section>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {
      announcement: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {};
    },
    mounted() {
      this.setAnnouncementText();
    },
    methods: {
      setAnnouncementText() {
        if (this.announcement.message && this.announcement.message.length > 0) {
          let html = '';
          this.announcement.message.split('\n').map(text => {
            html += `<p>${text}</p>`;
          });
          document.getElementById(`${this.announcement._id}-announcement-message`).innerHTML = html;
        }
      },
    },
  };
</script>
